/**
 * A still frame from a video, for exports that have no poster picture yet. It only starts
 * loading the video once the card scrolls into view — a list of these all opening their
 * files at once is what made the Exports tab slow.
 */
import React, { useEffect, useRef, useState } from "react";

interface Props {
  url: string;
  onClick?: () => void;
}

const InViewFrame: React.FC<Props> = ({ url, onClick }) => {
  const ref = useRef<HTMLVideoElement>(null);
  const [seen, setSeen] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el || seen) return;
    if (typeof IntersectionObserver === "undefined") { setSeen(true); return; }
    const io = new IntersectionObserver((entries) => {
      if (entries.some((e) => e.isIntersecting)) { setSeen(true); io.disconnect(); }
    }, { rootMargin: "200px" });
    io.observe(el);
    return () => io.disconnect();
  }, [seen]);

  return (
    <video
      ref={ref}
      className="th"
      src={seen ? `${url}#t=0.5` : undefined}
      muted
      preload={seen ? "metadata" : "none"}
      onClick={onClick}
      style={onClick ? { cursor: "pointer" } : undefined}
    />
  );
};

export default InViewFrame;
